import { render, staticRenderFns } from "./EncuestaCertificadoProlipa.vue?vue&type=template&id=28fe1cae"
import script from "./EncuestaCertificadoProlipa.vue?vue&type=script&lang=js"
export * from "./EncuestaCertificadoProlipa.vue?vue&type=script&lang=js"
import style0 from "./EncuestaCertificadoProlipa.vue?vue&type=style&index=0&id=28fe1cae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports